<div class="card">
  <app-grid-client-side
    storageKey="trusts"
    [pinFirstColumnName]="pinFirstColumnName"
    [rowData]="trusts"
    [colDefs]="$any(colDefs())"
    [pageTitle]="pageTitle"
    [loading]="isLoading()"
    [defaultExcelExportParams]="excelExportParams"
    [defaultCsvExportParams]="csvExportParams"
    [excelStyles]="excelStyles"
    (select)="selectTrust($event)"
    (gridReady)="onGridReady($event)"
  >
    <div class="grid-controls-middle d-flex justify-content-end gap-12" *appHasRole="['Admin', 'Manager', 'Preparer']">
      <button
        type="button"
        class="btn btn-primary d-flex align-items-center gap-8"
        [disabled]="modalOpened() || isLoading()"
        (click)="openSelectTrustEstablishmentModal()"
      >
        <i class="icon ic-add-20"></i>
        <span>Trust Establishment</span>
      </button>

      <button
        type="button"
        class="btn btn-secondary d-flex align-items-center gap-8"
        [disabled]="modalOpened() || isLoading()"
        (click)="addTrust()"
      >
        <i class="icon ic-add-20"></i>
        <span>Add Trust</span>
      </button>
    </div>

    <div class="grid-controls-end">
      @if (checkedTrust.length) {
        <div
          ngbDropdown
          class="dropdown"
          [placement]="['bottom-end', 'bottom-start', 'top-start', 'top-end']"
        >
          <button
            ngbDropdownToggle
            id="bulk-actions-dd"
            class="btn btn-secondary d-flex align-items-center gap-2"
            [disabled]="modalOpened() || isLoading()"
          >
            <span>Bulk actions</span>
            <i class="icon ic-select-20"></i>
          </button>

          <div
            ngbDropdownMenu
            aria-labelledby="bulk-actions-dd"
            class="common-dropdown-menu dropdown-menu dropdown-menu-right"
          >
            <button ngbDropdownItem (click)="exportSelectedTrustsToXls()">
              <span>Export List of Trusts to xlsx</span>
            </button>

<!--            <button ngbDropdownItem (click)="exportSelectedTrustsToCsv()">-->
<!--              <span>Export to csv</span>-->
<!--            </button>-->

            <button ngbDropdownItem (click)="manageTags()">
              <span>Manage Tags</span>
            </button>
          </div>
        </div>
      } @else {
        <app-button
          title="Export Trust List"
          btnColor="white"
          iconClass="icon ic-download-20"
          [isDisabled]="modalOpened() || isLoading() || !trusts.length"
          (clickBtn)="exportTrustList(false, ExportTypeEnum.EXCEL)"
        />
      }
    </div>
  </app-grid-client-side>
</div>

<app-notes
  [entityType]="EntityType.Trust"
  [entity]="entityForNotes"
  [opened]="notesVisible"
  (close)="notesVisible = false"
/>

<app-alerts-list
  [alerts]="alerts"
  [entityType]="EntityType.Trust"
  [entity]="entityForAlerts"
  [opened]="alertsVisible"
  (close)="alertsVisible = false"
  (alertReaded)="onAlertReaded($event)"
/>
